<template>
  <div>
    <Breadcrumbs
      v-if="isMyProduct && profile !== 'PROCUREMENT'"
      :breadcrumbs="[
        { text: $t('dashboardVue.dashboard'), link: 'welcome' },
        { text: 'Məhsullarım', link: 'myProductsPage' },
        { text: 'Məhsul', link: '', active: true },
      ]"
      :product="product"
    />
    <Breadcrumbs
      v-if="profile === 'PROCUREMENT'"
      :breadcrumbs="[
        { text: $t('dashboardVue.dashboard'), link: 'welcome' },
        { text: 'Məhsul axtarışı', link: 'productSearch' },
        { text: 'Məhsul', link: '', active: true },
      ]"
      :product="product"
    />
    <Breadcrumbs
      v-if="!isMyProduct"
      main-link="welcome"
      title="Məhsul"
      :main="$t('dashboardVue.dashboard')"
    />
    <!-- Container-fluid starts-->
    <div class="container mt-4">
      <!-- Edit Button -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <div
              v-if="isMyProduct && profile !== 'PROCUREMENT'"
              class="mb-3"
            >
              <div v-if="product.status === 'DRAFT'">
                <div class="alert alert-light shadow">
                  Bu məhsul qaralama stasusundadır, digər istifadəçilər bu məhsulu görmür. Məhsulu yayımlamaq üçün
                  lazımı əməliyyatları tamamlayın
                </div>
              </div>
              <div v-else-if="product.status === 'WAITING'">
                <div class="alert alert-light shadow">
                  Bu məhsul admininstrasiya tərəfindən yoxlama gözələyir.
                </div>
              </div>
              <div v-else-if="product.status === 'RETURNED'">
                <div class="alert alert-danger shadow text-wrap">
                  {{ $t('request.buSoruAdmininstrasiyaTrfindnGeriQaytarlmdr') }} <br>
                  <strong>{{ $t('request.sbb2') }}</strong> <span
                    class="d-inline-block text-truncate"
                    style="max-width: 100%;"
                  >{{ product.adminNote }}</span>
                  <hr>
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="mb-0">
                      Məhsulu təkrar göndərmək istəmirsinizsə silə bilərsiniz
                    </p>
                    <button
                      class="btn btn-sm p-2 btn-outline-danger"
                      @click="deleteProduct()"
                    >
                      {{ $t('request.sorunuSil') }}
                    </button>
                  </div>
                </div>
              </div>
              <div v-else-if="product.status === 'REJECTED'">
                <div class="alert alert-danger shadow">
                  {{ $t('request.buSoruAdmininstrasiyaTrfindnPaylalmasnaIcazVerilmy') }} <br>
                  <strong>{{ $t('request.sbb2') }}</strong> {{ product.adminNote }}
                  <hr>
                  <div class="d-flex justify-content-between align-items-center mt-3 ">
                    <button
                      class="btn btn-sm p-2 btn-outline-danger"
                      @click="deleteProduct()"
                    >
                      {{ $t('request.sorunuSil') }}
                    </button>
                  </div>
                </div>
              </div>
              <div v-else-if="product.status === 'ACTIVE' && isMyProduct">
                <div class="alert alert-success">
                  Sizin məhsulunuz aktivdir
                </div>
                <button
                  class="btn btn-success mt-2"
                  @click="showAdModal = true"
                >
                  Reklam yarat
                </button>

                <button
                  class="btn ml-2 mt-2 btn-outline-danger"
                  @click="deleteProduct()"
                >
                  {{ $t('request.sorunuSil') }}
                </button>
              </div>
              <div v-if="product.status === 'DRAFT' || product.status === 'RETURNED'">
                <div class="mb-4 d-flex justify-content-between align-items-center">
                  <div>
                    <button
                      class="btn btn-primary mr-3 mb-2"
                      @click.prevent="publishProduct"
                    >
                      <span> Məhsulu yayımla</span>
                    </button>
                    <button
                      class="btn btn-light-primary mr-3 mb-2"
                      @click.prevent="editProduct()"
                    >
                      <i class="fa fa-pencil-square mr-1" />
                      {{ $t('newAUCRequest.dzliEt') }}
                    </button>
                  </div>
                  <div>
                    <button
                      class="btn btn-light-danger ml-3 mb-2"
                      @click="deleteProduct()"
                    >
                      <i class="fa fa-trash mr-1" />
                      <span>Məhsulu sil</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 mb-4">
          <div class="card">
            <div class="card-body">
              <label
                for="new_request_sector"
                class="lead font-weight-bold"
              >
                <span>Məhsulun uyğun olduğu fəaliyyət sahələri</span>
              </label>
              <SelectedSectorView
                :sectors="productSectors"
                :parent-id="0"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-4">
          <div class="card shadow mb-4">
            <div class="card-body">
              <h4>Məhsul müəllifi</h4>
              <hr class="my-3">
              <div class="d-flex justify-content-between align-items-top">
                <div class="d-flex align-items-center">
                  <img
                    class="rounded-circle img-thumbnail mr-2"
                    style="width: 70px;"
                    :src="getPhoto(product.user?.photo, 'thumbnailCropped')"
                    alt=""
                  >
                  <div>
                    <strong>{{ product?.user?.name }} {{ product.user?.surname }}</strong> <br>
                    <span
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="openRatingPopup({ company: product.company, profile: 'SUPPLIER' })"
                    >
                      {{ product?.company?.name }} {{ getCompanyFormat(product?.company?.format) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 mb-4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <!-- Left column content -->
                  <div class="form-group">
                    <label>Məhsulun adı</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="product.name"
                      readonly
                    >
                  </div>
                  <div class="form-group">
                    <label>Açar sözlər</label>
                    <div class="keyword-container">
                      <span
                        v-for="(keyword, index) in productKeywords"
                        :key="index"
                        class="keyword-badge"
                      >
                        {{ keyword }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Məhsul haqqında məlumat</label>
                    <div
                      class="form-control"
                      style="height: auto;"
                      v-html="convertDescriptionToLinks(product.description || 'Təqdim edilmir')"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- Right column content -->
                  <div class="form-group">
                    <label>Məhsulun qiyməti/Vahid</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        :value="product.price"
                        readonly
                      >
                      <div>
                        <span class="input-group-text">{{ product.currency }}</span>
                      </div>
                      <div class="input-group-append">
                        <span class="input-group-text">1</span>
                      </div>
                      <div class="input-group-append">
                        <span class="input-group-text">{{ product.unit }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Qiymət təklifinin etibarlılıq müddəti</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="formatDate(product.validDate)"
                      readonly
                    >
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <span class="badge badge-light font-weight-normal">
                  <i class="fa fa-eye mr-1" />
                  {{ $t('request.requestviewcountDfBaxlb', {viewCount: product.viewCount}) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-4">
          <div
            v-if="['RETURNED', 'REJECTED', 'DRAFT'].indexOf(product.status) < 0"
            class="card shadow"
          >
            <div class="card-body">
              <h4>{{ $t('request.sorunuPayla') }}</h4>
              <hr class="my-2">
              <div class="d-flex flex-wrap">
                <ShareNetwork
                  v-for="network in networks"
                  :key="network.name"
                  :network="network.name"
                  :url="fullUrl"
                  :title="product.name"
                  :class="`btn btn-sm py-2 ${network.btnClass} m-2`"
                >
                  <i
                    :class="network.iconClass"
                    aria-hidden="true"
                  /> {{ $t(network.translationKey) }}
                </ShareNetwork>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Product Details -->
      <div class="row">
        <div class="col-lg-8 mb-4">
          <div class="card">
            <div class="card-body">
              <div class="row mt-4">
                <div class="col-md-12">
                  <label
                    for="new_request_sector"
                    class="lead font-weight-bold"
                  >
                    <span>Məhsul haqqında şəkillər</span>
                  </label>
                  <div class="d-flex flex-wrap">
                    <div
                      v-for="(url, index) in allImages"
                      :key="index"
                      class="image-container"
                    >
                      <img
                        :src="mediaBase + url"
                        class="img-fluid mb-2"
                        alt="Product Image"
                        @click="openGallery(index)"
                      >
                    </div>
                  </div>
                  <vue-easy-lightbox
                    :visible="galleryVisible"
                    :imgs="allImages?.map(url => mediaBase + url)"
                    :index="galleryIndex"
                    @hide="galleryVisible = false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 mb-4">
          <div class="card">
            <div class="card-body">
              <label class="col-form-label"><strong>Minimum sifariş miqdarı</strong></label>
              <div class="form-group row">
                <div
                  v-if="!!product?.totalPrices"
                  class="col-12"
                >
                  <div
                    v-for="(order, index) in Object.entries(product?.totalPrices)"
                    :key="index"
                    class="row mb-2"
                  >
                    <div class="col-sm-5">
                      <label>Say</label>
                      <div class="input-group">
                        <input
                          v-model="order[0]"
                          type="text"
                          class="form-control"
                          placeholder="100"
                          disabled
                        >
                        <div class="input-group-append">
                          <span class="input-group-text">{{ product.unit }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <label>Qiymət</label>
                      <div class="input-group">
                        <input
                          v-model="product.totalPrices[order[0]]"
                          type="text"
                          class="form-control"
                          placeholder="400"
                          disabled
                        >
                        <div class="input-group-append">
                          <span class="input-group-text">{{ product.currency }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Documents -->
      <div class="row">
        <div class="col-lg-8 mb-4">
          <div class="card">
            <div class="card-body">
              <div class="row mt-4">
                <div class="col-12">
                  <h3>Məhsulun sənədləri</h3>
                  <div class="grid-container">
                    <div
                      v-for="(doc, index) in product.documents"
                      :key="index"
                      class="grid-item"
                    >
                      <div class="card position-relative">
                        <a
                          target="_blank"
                          :href="mediaBase + doc"
                          class="card h-100 border border-dark text-center"
                        >
                          <div class="card-body d-flex justify-content-center align-items-center">
                            {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ doc.split('.').pop() }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="product?.documents?.length === 0">
                    Heç bir məlumat yoxdur
                  </div>
                </div>
              </div>

              <!-- Recommendations -->
              <div class="row mt-4">
                <div class="col-12">
                  <h3>Məhsul haqqında rəylər</h3>
                  <div class="grid-container">
                    <div
                      v-for="(rec, index) in product?.recommendations"
                      :key="index"
                      class="grid-item"
                    >
                      <div class="card position-relative">
                        <a
                          target="_blank"
                          :href="mediaBase + rec"
                          class="card h-100 border border-dark text-center"
                        >
                          <div class="card-body d-flex justify-content-center align-items-center">
                            {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ rec.split('.').pop() }}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="product?.recommendations?.length === 0">
                    Heç bir məlumat yoxdur
                  </div>
                </div>
              </div>

              <div
                v-if="!isMyProduct && !hasInquired"
                class="text-right mb-3"
              >
                <button
                  class="btn btn-info"
                  @click="handleInquiry"
                >
                  Mesaj yaz
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid ends-->

    <!-- Company Rating Modal -->
    <b-modal
      id="modal-company-rate-statists"
      centered
      ok-only
      ok-title="bağla"
      class="theme-modal"
    >
      <CompanyRateStatistics
        v-if="openCompanyRatingStatisticPopup > 0"
        :show-company="true"
        :company-id="openCompanyRatingStatisticPopup"
        :profile-type="openCompanyRatingStatisticPopupProfile"
      />
    </b-modal>
    <b-modal
      id="advertisement-modal"
      v-model="showAdModal"
      title="Reklam yarat"
      hide-footer
      size="lg"
    >
      <div>
        <!-- 1: Additional Text -->
        <p class="text-info">
          Bu məhsul/xidməti siz aşağıda seçdiyiniz 3 fəaliyyət sahəsi üzrə reklam edə bilərsiz. Reklam seçilmiş
          fəaliyyət sahələrində 1 gün müddətində aktiv yayımlanacaq.
        </p>

        <!-- 2: Additional Text -->
        <p class="mt-3 text-warning">
          Reklam etmək limitiniz sizin portalda seçdiyiniz tarifinizə görə müəyyən edilmişdir.
        </p>
        <label for="sectors">Fəaliyyət sahəsi</label>
        <SelectedSectorView
          :sectors="selectedSectors"
          :parent-id="0"
        />
        <div class="mt-3">
          <button
            v-b-modal.modal-sector-selection
            type="button"
            class="btn btn-sm btn-primary"
          >
            {{ $t('companyProfile.faliyytSahsiniSein') }}
          </button>
        </div>
      </div>

      <!-- 3: Additional Text -->
      <div class="mt-3 text-muted small">
        Siz aşağıdakı fəaliyyət sahələrindən 3-ünü seçərək reklamınızı yayımlaya bilərsiz.
      </div>

      <!-- Paylaş Button -->
      <div class="d-flex justify-content-end mt-3">
        <button
          class="btn btn-primary"
          @click="createAdvertisement"
        >
          Paylaş
        </button>
      </div>
    </b-modal>

    <!-- Sector Selection Modal -->
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-parent-selection="3"
        :max-selection="10"
        :parent-sector="null"
        :selected="selectedSectors"
        @done="sectorSelected"
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {advertiseProduct, deleteProduct, getProductById, publishProduct} from "@/repositories/ProductDataRepository";
import VueEasyLightbox from 'vue-easy-lightbox';
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue";
import Multiselect from 'vue-multiselect'
import {getCompanyFormat, getPhoto, getProfileName, showLimitExceedPopup} from "@/repositories/Utils";
import {createInquiry} from "@/repositories/InquiryDataRepository";
import CompanyRateStatistics from "@/pages/scc/company/CompanyRateStatistics.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";

export default {
  components: {
    Multiselect,
    StarRatingView,
    Sector_selection_modal,
    SelectedSectorView,
    VueEasyLightbox,
    CompanyRateStatistics,  // Import the CompanyRateStatistics component
  },
  data() {
    return {
      fullUrl: '',
      mediaBase: mediaBase,
      product: {},
      intervalId: null,
      isPolling: false,
      showAdModal: false,
      selectedSectors: [],
      selectedCountries: [],
      productSectors: [],
      galleryVisible: false,
      galleryIndex: 0,
      networks: [
        {
          name: 'facebook',
          iconClass: 'fa fa-fw fa-facebook-square',
          btnClass: 'btn-light-primary',
          translationKey: 'request.facebook'
        },
        {
          name: 'email',
          iconClass: 'fa fa-fw fa-at',
          btnClass: 'btn-light-primary',
          translationKey: 'request.emailGndr'
        },
        {
          name: 'linkedIn',
          iconClass: 'fa fa-fw fa-linkedin',
          btnClass: 'btn-light-primary',
          translationKey: 'companyProfile.linkedin2' // Assuming you don't have a translation key for LinkedIn
        },
        {
          name: 'telegram',
          iconClass: 'fa fa-fw fa-telegram',
          btnClass: 'btn-light-info',
          translationKey: 'request.telegram'
        },
        {
          name: 'whatsapp',
          iconClass: 'fa fa-fw fa-whatsapp',
          btnClass: 'btn-light-success',
          translationKey: 'companyProfile.whatsapp'
        }
      ],
      hasInquired: false,
      openCompanyRatingStatisticPopup: 0,
      openCompanyRatingStatisticPopupProfile: '',
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
    }),
    allImages() {
      const fileUrls = this.product?.fileUrls ?? []; // Ensure fileUrls is always an array
      return [this.product?.coverPhotoUrl, ...fileUrls];
    },
    countryOptions() {
      const countries = this.$t('countries'); // Fetches the countries translations based on the current locale
      return Object.keys(countries).map(code => {
        return `${countries[code]}`
        // The label that Vue Multiselect will display
      });
    },
    isMyProduct() {
      return this.user.id === this.product.user?.id
          || this.company.id === this.product.company?.id
    },
    productKeywords() {
      return this.product.keywords ? this.product.keywords.split(',').map(k => k.trim()) : [];
    }
  },
  mounted() {
    this.getProduct();
    this.fullUrl = window.location.href;
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    getPhoto,
    getCompanyFormat,
    getProfileName,
    handleInquiry() {
      this.$swal({
        title: 'Bu məhsul haqqında daha ətraflı məlumat almaq istəyirsiz?',
        input: 'textarea',
        inputLabel: 'Sualınızı bildirin',
        inputPlaceholder: 'Mesajınızı bura yazın',
        showCancelButton: true,
        confirmButtonText: 'Göndər',
        cancelButtonText: 'Bağla',
      }).then((result) => {
        if (result.isConfirmed) {
          this.createInquiry(result.value);
        }
      });
    },
    createInquiry(message) {
      const params = {
        productId: this.product.id,
        userId: this.user.id,
        inquiryText: message,
        companyId: this.company.id
      };
      createInquiry(this.token, params).then(d => {
        if (d.code === 200) {
          this.$swal({
            title: 'Mesajınız uğurla göndərildi',
            icon: 'success'
          });
        } else {
          this.$swal({
            title: `Error ${d.code}`,
            text: `${d.message}`,
            icon: 'error'
          });
        }
      }).catch(error => {
        this.$swal({
          title: 'Error',
          text: 'An error occurred while creating the inquiry.',
          icon: 'error'
        });
      })
    },
    deleteProduct() {
      this.$swal({
        title: this.$t("general.dltConfirm"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          deleteProduct(this.token, this.$route.params["id"]).then((data) => {
            if (data.code === 200) {
              this.$router.push({name: 'myProductsPage'})
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },
    publishProduct() {
      publishProduct(this.token, this.$route.params["id"]).then((data) => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("vendorManagementPurchasesReports.uurlu"),
            text: "Məhsul paylaşıldı",
            icon: "success",
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal({
            title: this.$t("err"),
            text: "Məhsul paylaşılan zaman xəta baş verdi",
            icon: "error",
          }).then(() => {
            this.$router.replace({name: "welcome"});
          });
        }
      })
    },
    getProduct() {
      getProductById(this.token, this.$route.params["id"]).then((data) => {
        if (data.code === 200) {
          this.product = data.product;
          this.productSectors = data.sectors;
          this.hasInquired = data.hasInquired;
          if (this.product.status === 'WAITING' && !this.isPolling) {
            this.startPolling();
            this.isPolling = true; // Set isPolling to true after starting polling
          } else if (this.product.status !== 'WAITING' && this.isPolling) {
            clearInterval(this.intervalId);
            this.isPolling = false; // Reset the polling flag
          }
        } else if (data.code === 403) {
          this.$router.push({
            name: "changeAccount",
            query: {next: `/dashboard/product/${this.$route.params["id"]}`},
          });
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("general.requestNotFound"),
            icon: "error",
          }).then(() => {
            this.$router.replace({name: "welcome"});
          });
        }
      });
    },
    editProduct() {
      this.$router.push({name: "editProduct", params: {id: this.product.id}});
    },
    formatDate(date) {
      if (!date) return "Təqdim edilmir";
      const d = new Date(date);
      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    },
    openGallery(index) {
      this.galleryIndex = index;
      this.galleryVisible = true;
    },
    convertDescriptionToLinks(description) {
      if (!description) return "Təqdim edilmir";
      const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
      return description.replace(urlRegex, (url) => {
        const href = url.startsWith('www.') ? `http://${url}` : url;
        return `<a href="${href}" target="_blank">${url}</a>`;
      });
    },
    openRatingPopup({company, profile}) {
      this.$bvModal.show('modal-company-rate-statists');
      this.openCompanyRatingStatisticPopup = company.id;
      this.openCompanyRatingStatisticPopupProfile = profile;
    },
    sectorSelected(sectors) {
      this.selectedSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    createAdvertisement() {
      try {
        advertiseProduct(this.token, this.product.id, this.selectedSectors.map(sector => sector.id)).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: 'Reklam yaradıldı!',
              text: 'Reklamınız uğurla yaradıldı.',
              icon: 'success',
            });
            this.showAdModal = false;
          } else if (data.code === 425) {
            showLimitExceedPopup(this.$swal, data.message, data.errorCode, false);
          } else {
            this.$swal({
              title: 'Xəta',
              text: data.message,
              icon: 'error',
            });
          }
        });

      } catch (error) {
        this.$swal({
          title: 'Xəta',
          text: 'Reklam yaratma zamanı xəta baş verdi.',
          icon: 'error',
        });
      }
    },
    startPolling() {
      this.intervalId = setInterval(() => {
        this.getProduct();
      }, 3000);
    }
  }

};
</script>

<style scoped>
.form-group label {
  font-weight: bold;
}

.img-fluid {
  max-height: 300px;
  object-fit: contain;
}

.image-container {
  flex: 0 0 12.5%; /* 100% / 8 = 12.5% */
  max-width: 25%;
  padding: 5px;
  box-sizing: border-box;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
}

.grid-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.keyword-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 5px;
}

.keyword-badge {
  display: inline-flex;
  align-items: center;
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
}
</style>
